import { KenshoLogotype } from "@kensho/branding";
import { use } from "react";
import { Outlet } from "react-router";

import { SignInDialog } from "../components/sign-in-dialog";
import { UserContext } from "../providers/user-context";

export function Auth() {
  const { user, _state: userState } = use(UserContext);

  if (user) return <Outlet />;

  return (
    <div className="flex h-screen items-center justify-center">
      <SignInDialog isOpen={userState === "known"} />
      <KenshoLogotype height="50%" width="50%" />
    </div>
  );
}
